import React from "react";
import { formatPrice } from "../../utilities/currencyUtility";
import "./PriceDisplay.module.scss";

interface IPriceDisplayProps {
  /** Amount, in the currency identified by `currencyId` (EUR when omitted). */
  minPrice: number;
  /** Upper bound of a price range, in the same currency as `minPrice`. */
  maxPrice?: number;
  /**
   * Currency the amount was recorded in. Omit for EUR — the only case where
   * this matters is a legacy payment stored in BGN, which must be shown in BGN.
   */
  currencyId?: number | null;
  /** CSS class name */
  className?: string;
  /** Stack prices vertically on mobile */
  stackOnMobile?: boolean;
}

export const PriceDisplay = ({
  minPrice,
  maxPrice,
  currencyId,
  className,
  stackOnMobile = false,
}: IPriceDisplayProps) => {
  const effectiveMaxPrice = maxPrice ?? minPrice;
  const isSinglePrice = minPrice === effectiveMaxPrice;

  const min = formatPrice(minPrice, currencyId);
  const max = formatPrice(effectiveMaxPrice, currencyId);

  const wrapperClass = stackOnMobile ? "price-display-stack-mobile" : undefined;
  const combinedClassName = [className, wrapperClass].filter(Boolean).join(" ");

  if (isSinglePrice) {
    return (
      <span className={combinedClassName}>
        <span>{min}</span>
      </span>
    );
  }

  return (
    <span className={combinedClassName}>
      <span>
        {min} - {max}
      </span>
    </span>
  );
};
